<template>
    <form :id="widgetType" @submit.prevent="addNewWidget" >
    <label class="form-label">Nombre de Variable</label>
    <input
        class="form-control"
        v-model="widgetConfig.variableFullName"
        type="text"
        required
    />

    <div>
        <label for="" class="form-label">ID Variable (MQTT)</label>
        <input
          class="form-control"
          v-model="widgetConfig.variable"
          type="text"
        />
    </div>
  
    <label class="form-label">Frecuencia de envio</label>
    <input
        class="form-control"
        v-model.number="widgetConfig.variableSendFreq"
        type="number"
        required
    />
    <label class="form-label">Texto->boton</label>
    <input
        class="form-control"
        v-model="widgetConfig.text"
        type="text"
        required
    />
    <label class="form-label">Icono</label>
    <IconsForm :value="widgetConfig"></IconsForm>
    
    <label class="form-label">Seleccionar Color</label>
    <select
        v-model="widgetConfig.class"
        class="form-select"
        style="width: 100%"
    >
        <option
        class="text-success"
        value="success"
        label="Success"
        ></option>
        <option
        class="text-primary"
        value="primary"
        label="Primary"
        ></option>
        <option
        class="text-warning"
        value="warning"
        label="Warning"
        ></option>
        <option
        class="text-danger"
        value="danger"
        label="Danger"
        ></option>
    </select>

    <label class="form-label">Seleccionar Tamaño</label>
    <select
        v-model="widgetConfig.column"
        class="form-select"
        style="width: 100%"
        required
    >
        <option value="col-md-3 col-sm-12" label="Pequeño"></option>

        <option value="col-md-6 col-sm-12" label="Mediano"></option>

        <option value="col-12" label="Grande"></option>
    </select>    
    </form>
</template>

<script>
import IconsForm from './IconsForm.vue';
export default {
    components:{
        IconsForm,
    },
    props: ["widgetConfig", "addNewWidget", "widgetType"],
    
}

</script>